var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTariffCheck = function SvgTariffCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.374 16.7c4.55 0 8.237-3.69 8.237-8.24 0-4.548-3.687-8.236-8.236-8.236C3.824.224.137 3.912.137 8.46c0 4.55 3.688 8.24 8.237 8.24",
    fill: "#70B27D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.329,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.52 8.56l2.394 2.37 4.576-4.516"
  }))));
};
export default SvgTariffCheck;